import React from "react";
import SEO from "../../hooks/SEO";
import NotFoundSection from "../../components/NotFound";
import { seoContent, siteMeta } from "../../data/mockData";

const NotFoundPage = () => (
  <>
    <SEO
      title={seoContent.notFound.title}
      description={seoContent.notFound.description}
      name={siteMeta.name}
      type="website"
    />
    <NotFoundSection />
  </>
);

export default NotFoundPage;
